import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText } from "../../../../utils";

interface TemplateArgs {
    className?: string;
    title?: string;
    subtitle?: string;
    variant?: string;
}

export const Template = ({
    className,
    title,
    subtitle,
    variant,
}: TemplateArgs) => html`
    <ux-iws-nb-product-benefits
        class=${ifDefined(className)}
        variant=${ifDefined(variant)}
    >
        ${title ? html`<h2 slot="title">${title}</h2>` : ""}
        ${subtitle ? html`<div slot="subtitle">${subtitle}</div>` : ""}
        <ul>
            <li>
                <h3>Höchste Präzision</h3>
                ${getDummyText(100)}
            </li>
            <li>
                <h3>Ein Hersteller</h3>
                ${getDummyText(150)}
            </li>
            <li>
                <h3>Null Kompromisse</h3>
                ${getDummyText(80)}
            </li>
            <li>
                <h3>Höchste Präzision</h3>
                ${getDummyText(240)}
            </li>
            <li>
                <h3>Ein Hersteller</h3>
                ${getDummyText(150)}
            </li>
        </ul>
    </ux-iws-nb-product-benefits>
`;

export const templateArgs = {
    title: "Weitere Vorteile der TRUMPF All-in-One Lösung",
    subtitle: "",
    variant: "light",
};
